import styled from 'styled-components'

// Constants
import {colors} from '~/constants/style'

const LatestBL = styled.div`
  margin-bottom: 40px;
`

LatestBL.Title = styled.div`
  font-size: 1.75rem;
  font-weight: bold;
  margin-bottom: 12px;
`

LatestBL.ItemsWrapper = styled.div``

LatestBL.Item = styled.a`
  display: flex;
  align-items: center;
  
  &:hover {
    text-decoration: none;
  }

  &:not(:last-child) {
    margin-bottom: 7px;
  }
`

LatestBL.ItemThumbnail = styled.div`
  flex: 60px 0 0;
  height: 60px;
  margin-right: 15px;
  display: flex;
  position: relative;
`

LatestBL.ItemRight = styled.div`
  padding: 5px 0;
`

LatestBL.ItemDate = styled.div`
  color: ${colors.green};
  margin-bottom: 3px;
`

LatestBL.ItemTitle = styled.h2`
  font-weight: 600;
  color: black;
  font-size: 1rem;
`

export default LatestBL
